import { makeOfferUpdateOperation } from '@occc-app/offerHelpers/operations/makeOfferUpdateOperation';
import { isFieldDirty } from '@occc-app/offerHelpers/utils';
import { OfferUpdateInput } from '@occc/graphql';
import { Operation } from '@occc-app/offerHelpers/types';
import { ConfigurationFormNameAndDescriptionValues } from '../../../types';

export const getOfferNameAndDescriptionUpdateOperations = (
  offerId: string,
  values: ConfigurationFormNameAndDescriptionValues,
  dirtyFields: { [key: string]: boolean },
): Operation[] => {
  const offerUpdatePayload: Partial<OfferUpdateInput> = {};

  if (isFieldDirty<ConfigurationFormNameAndDescriptionValues>(dirtyFields, 'name')) {
    offerUpdatePayload.name = values.name;
  }
  if (isFieldDirty<ConfigurationFormNameAndDescriptionValues>(dirtyFields, 'description')) {
    offerUpdatePayload.description = values.description ?? null;
  }

  if (Object.keys(offerUpdatePayload).length === 0) {
    return [];
  }

  return [makeOfferUpdateOperation(offerId, offerUpdatePayload as OfferUpdateInput)];
};
